module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/social/facebook-45d987ae95206a12acafcc08a48db192.svg";